"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Tue Aug 07 2018
 */

var SingleTargetStrategy_1 = require("./SingleTargetStrategy");

var StrategyTypeEnum_1 = require("./StrategyTypeEnum");
/**
 * Define the relations with the relevant competitors. Only one strategy and distance can be applied.
 *
 * @author RV
 */


var NotMoreExpensiveThan =
/*#__PURE__*/
function (_SingleTargetStrategy) {
  _inherits(NotMoreExpensiveThan, _SingleTargetStrategy);

  /**
   * @param competitorId
   */
  function NotMoreExpensiveThan(competitorId) {
    var _this;

    _classCallCheck(this, NotMoreExpensiveThan);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NotMoreExpensiveThan).call(this, competitorId));
    _this.competitorId = competitorId;
    return _this;
  }

  _createClass(NotMoreExpensiveThan, [{
    key: "getType",
    value: function getType() {
      return StrategyTypeEnum_1.StrategyTypeEnum.NotMoreExpensiveThan;
    }
  }]);

  return NotMoreExpensiveThan;
}(SingleTargetStrategy_1.SingleTargetStrategy);

exports.NotMoreExpensiveThan = NotMoreExpensiveThan;